import React from 'react';
import { Spinner} from 'react-bootstrap';
import './Spinner.css' 

const spinner = () => (
    <div id="overlay">
        <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
        </Spinner>
    </div>
);

export default spinner;